/**
 * index.jsx
 * Application entry point.
 * Creates the MSAL PublicClientApplication instance and renders the root.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import App from "./App";

// ── MSAL instance (singleton — created once at startup) ────────────────────
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering.
// This handles the redirect callback after Microsoft login.
msalInstance.initialize().then(() => {

  // If MSAL returns from a redirect (post-login), set the active account.
  msalInstance.addEventCallback(event => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload?.account
    ) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  // If an account is already cached, set it as active.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App msalInstance={msalInstance} />
    </React.StrictMode>
  );
});
